module.exports = __webpack_public_path__ + "img/avterracebox04.fb8148ef.jpg";